import { uiStrings } from '../../lib/strings'
import { text } from '../../lib/text'
import { firstStepIdOfKind } from '../navigation'
import type { StepProps } from '../types'

export function WelcomeStep({ step, ctx }: StepProps<'welcome'>) {
  const { view, locale } = ctx
  const t = uiStrings(locale)
  const browseStepId = firstStepIdOfKind(view.flow, 'browse')
  const visit = view.visit

  return (
    <div className="mx-auto flex w-full max-w-[520px] flex-1 flex-col justify-between px-6 pb-10">
      <div className="pt-16">
        {visit ? (
          <p className="fr-eyebrow mb-8">
            {visit.tierLabel}
            {visit.customerName ? ` · ${visit.customerName}` : ''}
          </p>
        ) : (
          <p className="fr-eyebrow mb-8">{text(view.flow.label, locale)}</p>
        )}

        <h1 className="fr-display text-[3.25rem] leading-[0.98] tracking-tight">
          {text(step.title, locale) || view.tenant.branding.displayName}
        </h1>

        {step.body ? (
          <p className="mt-7 max-w-[34ch] text-[1.0625rem] font-light leading-relaxed" style={{ color: 'var(--fr-ink-dim)' }}>
            {text(step.body, locale)}
          </p>
        ) : null}

        {step.bullets.length > 0 ? (
          <ol className="mt-12 space-y-0 border-t" style={{ borderColor: 'var(--fr-rule)' }}>
            {step.bullets.map((bullet, index) => (
              <li
                key={`${index}-${bullet.default}`}
                className="flex items-baseline gap-5 border-b py-4"
                style={{ borderColor: 'var(--fr-rule)' }}
              >
                <span className="fr-display text-[1.5rem] tabular-nums" style={{ color: 'var(--fr-primary)' }}>
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="text-[0.9375rem] leading-relaxed" style={{ color: 'var(--fr-ink-dim)' }}>
                  {text(bullet, locale)}
                </span>
              </li>
            ))}
          </ol>
        ) : null}
      </div>

      <div className="pt-14">
        <button
          type="button"
          className="fr-btn fr-btn-primary w-full"
          disabled={ctx.pending || !ctx.hasNext}
          onClick={() => ctx.advance()}
        >
          {text(step.ctaLabel, locale) || t.continue}
        </button>

        {step.allowSkipToBrowse && browseStepId ? (
          <div className="mt-3 text-center">
            <button type="button" className="fr-btn-quiet fr-btn-target" disabled={ctx.pending} onClick={() => ctx.goTo(browseStepId)}>
              {t.skipToBrowse}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  )
}
